import type { Interval } from "luxon";

const unionIntervals = (totalInterval: Interval, newInterval: Interval) =>
  totalInterval.union(newInterval);

export default unionIntervals;
